<template>
  <section class="app-main" ref="appMain">
    <!-- Vue3/VR4 标准写法：v2 的 <transition><keep-alive><router-view/> 嵌套在 Vue3 下
         KeepAlive 只会作用于 RouterView 包装组件本身，页面组件的 activated() 永不触发 -->
    <router-view v-slot="{ Component }">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="keepAliveDatas">
          <component :is="Component" :key="key"></component>
        </keep-alive>
      </transition>
    </router-view>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppMain',
  computed: {
    ...mapGetters({
      keepAliveData: 'keepAliveData'
    }),
    keepAliveDatas() {
      return this.keepAliveData || []
    },
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.fullPath
    }
  },
  watch: {
    $route() {
      this.$refs.appMain.scrollTop = 0
    }
  }
}
</script>

<style scoped>
.app-main {
  width: 100%;
  height: calc(100% - 35px);
  position: relative;
  overflow: auto;
  background-color: #efefef;
  box-sizing: border-box;
}
</style>
